export const DiccionarioSeguridad_ES = [
    {
        'codigo': 'CodeRequeridoEmailOName',
        'mensaje': 'Debe ingresar un filtro de búsqueda'
    },
    {
        'codigo': 'UserReqCompany',
        'mensaje': 'El usuario requiere estar vinculado al menos a una compañía'
    },
    {
        'codigo': 'CustomerExistUser',
        'mensaje': 'El Administrativo seleccionado ya se encuentra vinculado a otro usuario.'
    },
    {
        'codigo': 'ErrorClaveNoCoincide',
        'mensaje': 'La clave actual no coincide'
    },
    {
        'codigo': 'ErrorCodeItemNotEmty',
        'mensaje': 'El código es requerido'
    },
    {
        'codigo': 'ErrorCreatingPerfil',
        'mensaje': 'Se presentaron problemas al crear el perfil de seguridad'
    },
    {
        'codigo': 'ErrorCurrentCompaniaNotEmpty',
        'mensaje': 'No se encontraron los datos de la compañía'
    },
    {
        'codigo': 'ErrorSecProfileIdNotEmty',
        'mensaje': 'Debe seleccionar el perfil de seguridad'
    },
    {
        'codigo': 'ErrorDeletePerfil',
        'mensaje': 'Se presentaron problemas al eliminar el perfil de seguridad'
    },
    {
        'codigo': 'ErrorDscNotEmpty',
        'mensaje': 'La descripción es requerida'
    },
    {
        'codigo': 'ErrorEliminarUsuario',
        'mensaje': 'Se presentaron problemas al eliminar el usuario'
    },
    {
        'codigo': 'ErrorExisteCorreo',
        'mensaje': 'El correo ingresado ya se encuentra registrado para otro usuario'
    },
    {
        'codigo': 'ErrorExisteUsuario',
        'mensaje': 'No se encontraron los datos del usuario a actualizar'
    },
    {
        'codigo': 'ErrorExisteUsuarioEmail',
        'mensaje': 'Ya existe un usuario registrado con este correo electrónico'
    },
    {
        'codigo': 'ErrorGetPerfil',
        'mensaje': 'Se presentaron problemas al obtener los datos del perfil de seguridad'
    },
    {
        'codigo': 'ErrorGetUsuarioDetalle',
        'mensaje': 'Se presentaron problemas al obtener los datos del usuario'
    },
    {
        'codigo': 'ErrorModuleIdNotEmty',
        'mensaje': 'No se encontraron los datos del módulo'
    },
    {
        'codigo': 'ErrorUpdatePerfil',
        'mensaje': 'Se presentaron problemas al actualizar el perfil de seguridad'
    },
    {
        'codigo': 'ErrorUpdateSedesUsuario',
        'mensaje': 'Se presentaron problemas al actualizar las sedes del usuario'
    },
    {
        'codigo': 'ErrorUpdateUsuarioPerfil',
        'mensaje': 'Se presentaron problemas al actualizar las los perfiles de seguridad del usuario'
    },
    {
        'codigo': 'ErrorValidatingPerfil',
        'mensaje': 'Se presentaron problemas al validar el perfil de seguridad'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'Formato de archivo (extensión) no permitido.'
    },
    {
        'codigo': 'CodeRangeDate1Year',
        'mensaje': 'No debe haber más de 1 año de diferencia entre la fecha inicial y la fecha de fin.'
    },
    {
        'codigo': 'CodeRequeridoListaOpciones',
        'mensaje': 'No hay registros seleccionados para actualizar.'
    },
    {
        'codigo': 'CodeMinimoMaximoCharacters',
        'mensaje': 'El mínimo de carácteres no debe superar el valor máximo.'
    },
    {
        'codigo': 'CodeRequeridoEmail',
        'mensaje': 'El correo electrónico es requerido.'
    },
    {
        'codigo': 'CodeRequeridoPerfilId',
        'mensaje': 'No se encontraron los datos del perfil de seguridad.'
    },
    {
        'codigo': 'CodeRequeridoMinimo',
        'mensaje': 'El valor mínimo es requerido.'
    },
    {
        'codigo': 'CodeRequeridoMaximo',
        'mensaje': 'El valor máximo es requerido.'
    },
    {
        'codigo': 'CodeRequeridoHistory',
        'mensaje': 'The password history number is required.'
    },
    {
        'codigo': 'CodeRequeridoValidity',
        'mensaje': 'Debe ingresar la cantidad de días de validez.'
    },
    {
        'codigo': 'CodeRequeridoOldPassword',
        'mensaje': 'Debe ingresar su contraseña actual.'
    },
    {
        'codigo': 'CodeRequeridoPassword',
        'mensaje': 'Debe ingresar la nueva contraseña.'
    },
    {
        'codigo': 'CodeRequeridoConfirmacionPassword',
        'mensaje': 'Debe ingresar la contraseña de confirmación.'
    },
    {
        'codigo': 'CodeRequeridoDepartment',
        'mensaje': 'Debe ingresar el departamento.'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'Debe ingresar una contraseña.'
    },
    {
        'codigo': 'ErrorEmailNotEmty',
        'mensaje': 'Debe ingresar un correo electrónico.'
    },
];
